import Vue from 'vue'

/**
 * 删除公司
 * @param {*} params
 */
export const deleteCompany = params => {
  return Vue.fetch.post('/apiv1/hr/company/deleteCompany', params)
}

/**
 * 获取公司列表
 * @param {} params
 */
export const findCompanyList = params => {
  return Vue.fetch.post('/apiv1/hr/company/findCompanyList', params)
}

export const query = params => {
  return Vue.fetch.post('/apiv1/company/options/query', params)
}

export const add = params => {
  return Vue.fetch.post('/apiv1/company/options/add', params)
}

export const update = params => {
  return Vue.fetch.post('/apiv1/company/options/update', params)
}

export const remove = params => {
  return Vue.fetch.post('/apiv1/company/options/remove', params)
}

export const companyUpdateTotal = params => {
  return Vue.fetch.post('/apiv1/hr/company/companyUpdateTotal', params)
}



// WEBPACK FOOTER //
// ./src/services/tenantSettingApi.js